<template>
    <!-- 该插件使用了elementUI的样式，故必须引入elementUI才可正常使用 -->
    <div
        class="world-box"
        :style="onDown ? 'pointer-events: auto;' : 'pointer-events: none;'"
        @mousemove="mousemove"
        @mouseup="mouseup"
    >
        <div v-if="propVisible" class="dialog-box-modal"></div>
        <div
            :class="'dialog-box ' + dialogClassName"
            v-show="visible"
            :style="{
                width: width + 'px',
                left: left + 'px',
                top: top + 'px',
            }"
        >
            <!-- 标题 -->
            <div
                class="dialog-title"
                @mousedown="mousedown"
                @contextmenu="(e) => e.preventDefault()"
            >
                {{ title }}
            </div>
            <!-- icon -->
            <i class="el-icon-close d-icon" @click="visible = false"></i>
            <!-- 内容 -->
            <div class="dialog-content" ref="content">
                <slot />
            </div>
            <!-- 底部按钮 -->
            <span class="dialog-footer">
                <el-button @click="visible = false">返回</el-button>
            </span>
        </div>
    </div>
</template>

<script>
export default {
    model: {
        prop: "propVisible",
        event: "updateVisible",
    },
    props: {
        // 标题
        title: {
            type: String,
            default: "",
        },
        // visible v-model
        propVisible: {
            type: Boolean,
            required: true,
        },
        // 宽度
        width: {
            type: Number,
            default: 800,
        },
    },
    data() {
        return {
            dialogClassName: "", // 动画效果样式
            timeout2: undefined, // setTimeout缓存
            timeout: undefined, // setTimeout缓存
            left: 0, // 当前定位
            top: 60, // 当前定位
            onDown: false, // 是否正在拖动中
            cacheLeft: 0, // 拖动时定位
            cacheTop: 60, // 拖动时定位
            pageX: 0, // 按下时的鼠标位置
            pageY: 0, // 按下时的鼠标位置
        };
    },
    computed: {
        visible: {
            get() {
                return this.propVisible;
            },
            set(e) {
                if (e) {
                    this.$emit("updateVisible", e);
                } else {
                    // 隐藏时样式处理
                    this.dialogClassName =
                        "dialog-fade-leave-active dialog-fade-leave-to";
                    // 在隐藏时延时100毫秒执行，用来展示动画
                    if (this.timeout2) clearTimeout(this.timeout2);
                    this.timeout2 = setTimeout(() => {
                        this.$emit("updateVisible", e);
                    }, 100);
                }
            },
        },
    },
    watch: {
        /**
         * 显示样式处理
         */
        visible(e) {
            if (e) {
                // 显示时样式处理
                this.dialogClassName =
                    "dialog-fade-enter-active dialog-fade-enter-to";
                this.$refs.content.scrollTop = 0; // 重置滚动条
            }
        },
        /**
         * 动画结束后清除样式
         */
        dialogClassName(e) {
            if (e !== "") {
                if (this.timeout) clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    this.dialogClassName = "";
                }, 200);
            }
        },
    },
    methods: {
        /**
         * 按下
         */
        mousedown(e) {
            this.onDown = true;
            this.pageX = e.pageX;
            this.pageY = e.pageY;
            this.cacheLeft = this.left;
            this.cacheTop = this.top;
        },
        /**
         * 拖动(将拖动与松开绑定到world-box上，以实现更好的交互效果)
         */
        mousemove(e) {
            if (this.onDown) {
                let left = this.cacheLeft + (e.pageX - this.pageX);
                let top = this.cacheTop + (e.pageY - this.pageY);
                this.left = left > 0 ? left : 0;
                this.top = top > 0 ? top : 0;
            }
        },
        /**
         * 松开(将拖动与松开绑定到world-box上，以实现更好的交互效果)
         */
        mouseup(e) {
            if (this.onDown) this.onDown = false;
        },
    },
    mounted() {
        let htmlWidth = (document.documentElement || document.body).clientWidth;
        this.left = Math.floor((htmlWidth - this.width) / 2); // 获取弹窗居中位置
    },
};
</script>

<style lang="scss" scoped>
.world-box {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    margin: 0 auto;
    z-index: 2002;
    .dialog-box-modal {
        position: fixed;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        margin: 0 auto;
        z-index: 2003;
        background-color: rgba(0, 0, 0, 0.5);
    }
    .dialog-box {
        pointer-events: auto;
        border-radius: 10px !important;
        background-color: #fff;
        position: fixed;
        z-index: 2004;
        width: 800px;
        display: flex;
        flex-direction: column;
        box-shadow: 5px 2px 15px #00000033;
        .dialog-title {
            cursor: move;
            user-select: none;
            padding: 32px 30px 0px;
            text-align: center;
            font-size: 18px;
            font-weight: 600;
        }
        .d-icon {
            position: absolute;
            right: 15px;
            top: 15px;
            cursor: pointer;
            font-size: 24px;
        }
        .dialog-content {
            padding: 20px 30px 30px;
            max-height: 60vh;
            overflow: hidden;
            overflow-y: auto;
        }
        .dialog-footer {
            box-sizing: border-box;
            width: 100%;
            padding: 10px 20px 20px;
            text-align: center;
        }
    }
}
</style>